export default "__VITE_ASSET__Di$xhx6i__"